import { mockInsightStatusQueryQuery } from '__generated__';
import { delay, HttpResponse } from 'msw';

export const handlers = [
  mockInsightStatusQueryQuery(
    async ({ query: _query, variables: _variables }) => {
      await delay(150);
      return HttpResponse.json({
        data: {
          __typename: 'Query',
          insightStatus: {
            id: '3',
            color: '#D63A2E',
            __typename: 'InsightStatus',
          },
        },
      });
    }
  ),
];
